import axios from "axios";
import qs from "qs";
import { captureException } from "@sentry/react";
import { toast } from "react-toastify";

interface User {
  username: string;
  password: string;
}

const AuthService = {
  login: async (user: User) => {
    const loginAPI = `${process.env.REACT_APP_DELEND_API}/auth/token`;

    const request: any = {
      ...user,
      grant_type: "password",
    };

    const formData = new FormData();
    Object.keys(request).forEach((key) => {
      formData.append(key, request[key]);
    });

    const config = {
      method: "post",
      url: loginAPI,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(request),
    };

    try {
      const response = await axios(config);
      const token = response.data.access_token;
      const refreshToken = response.data.refresh_token;

      if (!token) {
        alert("Unable to login. Please try after some time.");
        return;
      }

      const clearLocalStorage = async () => {
        const viewedTipsPersistance = localStorage.getItem("viewedTips");
        await localStorage.clear();
        if (viewedTipsPersistance) {
          localStorage.setItem("viewedTips", "true");
        }
      };

      clearLocalStorage();

      localStorage.setItem("user-token", token);
      localStorage.setItem("user-refresh-token", refreshToken);
      return response;
    } catch (error: any) {
      if (error.response.status !== 401) {
        captureException(error);
        toast.error(error.response.data.errorDescription);
      }

      return error.response;
    }
  },
  refreshToken: async () => {
    const loginAPI = `${process.env.REACT_APP_DELEND_API}/auth/token`;
    const refreshToken = localStorage.getItem("user-refresh-token");

    const request: any = {
      refresh_token: refreshToken,
      grant_type: "refresh_token",
    };

    const formData = new FormData();
    Object.keys(request).forEach((key) => {
      formData.append(key, request[key]);
    });

    const config = {
      method: "post",
      url: loginAPI,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(request),
    };

    try {
      const response = await axios(config);
      const token = response.data.access_token;
      const newRefreshToken = response.data.refresh_token;
      localStorage.setItem("user-token", token);
      localStorage.setItem("user-refresh-token", newRefreshToken);

      return newRefreshToken;
    } catch (error: any) {
      throw new Error(error);
    }
  },
};

export default AuthService;
